import { apiGet, apiPost } from '../api/client';

export const DOCUMENT_KEYS = Object.freeze({
  RENT_ORDER: 'rent_order',
  SALE_ORDER_FLAT: 'sale_order_flat',
  SALE_ORDER_HOUSE: 'sale_order_house',
  RESERVATION_CONTRACT: 'reservation_contract',
});

export const DOCUMENT_DRAFT_SCHEMA_VERSION = 1;

function normalizeScope({ kod_ku, cislo_lv, document_key, user_id }) {
  return {
    kod_ku: String(kod_ku || '').trim(),
    cislo_lv: String(cislo_lv || '').trim(),
    document_key: String(document_key || '').trim(),
    user_id: user_id ? String(user_id).trim() : '',
  };
}

function buildDraftPath(scope) {
  const normalized = normalizeScope(scope);
  const params = new URLSearchParams({
    kod_ku: normalized.kod_ku,
    cislo_lv: normalized.cislo_lv,
    document_key: normalized.document_key,
  });
  if (normalized.user_id) params.set('user_id', normalized.user_id);
  return `/api/property-document-draft?${params.toString()}`;
}

export async function loadDocumentDraft(scope, getToken) {
  const normalized = normalizeScope(scope);
  if (!normalized.kod_ku || !normalized.cislo_lv || !normalized.document_key) return null;

  const res = await apiGet(buildDraftPath(normalized), getToken);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to load document draft.');
  }
  return data.draft || null;
}

export async function saveDocumentDraft(scope, payload, getToken) {
  const normalized = normalizeScope(scope);
  if (!normalized.kod_ku || !normalized.cislo_lv || !normalized.document_key) return null;
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;

  const res = await apiPost(
    '/api/property-document-draft',
    {
      ...normalized,
      payload,
      payload_schema_version: DOCUMENT_DRAFT_SCHEMA_VERSION,
    },
    getToken,
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to save document draft.');
  }
  return data.draft || null;
}
